<script lang="ts" setup></script>

<template>
  <svg
    fill="none"
    height="100%"
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      fill="black"
      fill-opacity="0.8"
      stroke="#D5B56E"
      stroke-width="3"
    />
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      fill="black"
      fill-opacity="0.8"
      stroke="black"
      stroke-opacity="0.8"
      stroke-width="3"
    />
    <path
      d="M8.00977 12.5L11.0097 15.5L16.0097 9.5"
      stroke="#D5B56E"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>

<style scoped></style>
